import FieldType from '../../components/Form/Fields/type'
import match from '../../components/Form/utils/match'
import { emailRequired, lengthRequired } from '@polvo-labs/form-utils'
import Password from '../../components/Form/Fields/Password'

export interface ResetFormData {
  email: string
  password: string
  password_confirmation: string
}

export type ResetForm = keyof ResetFormData

const fields: FieldType<ResetForm>[] = [
  {
    name: 'email',
    data: {
      icon: 'mail',
      label: 'Informe seu email de cadastro no IPTU',
    },
    validation: emailRequired,
    html: {
      maxLength: 255,
      placeholder: 'nome@email.com',
    },
  },
  {
    name: 'password',
    component: Password,
    data: {
      icon: 'password',
      label: 'Senha',
    },
    validation: lengthRequired({ min: 0, max: 255 }),
  },
  {
    name: 'password_confirmation',
    component: Password,
    data: {
      icon: 'password',
      label: 'Confirmar Senha',
    },
    validation: {
      validate: match<ResetFormData>('password', 'Senhas não batem'),
    },
  },
]

export default fields
